import { render, staticRenderFns } from "./mobileIndex.vue?vue&type=template&id=740f9bbf&scoped=true"
import script from "./mobileIndex.vue?vue&type=script&lang=js"
export * from "./mobileIndex.vue?vue&type=script&lang=js"
import style0 from "./mobileIndex.vue?vue&type=style&index=0&id=740f9bbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740f9bbf",
  null
  
)

export default component.exports